module.exports = __webpack_public_path__ + "static/fonts/OpenSans600.096d8c73.ttf";